import React from "react";
import { FormattedMessage } from "react-intl";

import { Icon, Typography } from "@treelab/panda";

import { GlobalError } from "../../constants/svg";

import { Container, Main, Mask } from "./styled";

interface IProps {
  errorMessage?: string;
  errorMessageId?: string;
}

const Error: React.FC<IProps> = ({ errorMessage, errorMessageId }) => {
  return (
    <Container>
      <Mask />
      <Main>
        <Icon icon={GlobalError} size={{ height: 60 }} style={{ marginBottom: "20px" }} />
        <Typography type={"h3"} style={{ marginBottom: "10px" }}>
          <FormattedMessage id="global.error.oops" />
        </Typography>
      </Main>
    </Container>
  );
};

export default Error;
